// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import InvoiceGroupEditScreen from "../../src/screens/invoice-groups/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} InvoiceGroupNewRouteProps */

/** @typedef {Record<string, never>} InvoiceGroupNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<InvoiceGroupNewRouteProps, InvoiceGroupNewRouteState>}
 */
class InvoiceGroupNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New invoice group")}</ScreenTitle>
        <InvoiceGroupEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<InvoiceGroupNewRouteProps>} */
const InvoiceGroupNewRouteComponent = memo(shapeComponent(InvoiceGroupNewRoute))

export default InvoiceGroupNewRouteComponent
